import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"play\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M250 475C374.264 475 475 374.264 475 250C475 125.736 374.264 25 250 25C125.736 25 25 125.736 25 250C25 374.264 125.736 475 250 475ZM313.868 251.59C315.094 250.883 315.094 249.114 313.868 248.407L227.336 198.448C226.111 197.74 224.58 198.624 224.58 200.039V299.957C224.58 301.372 226.111 302.256 227.336 301.549L313.868 251.59Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol